module.exports = __webpack_public_path__ + "img/大洋精锻盐智钉项目启动会.ecbfc405.jpg";